import { render } from "./HoldingRow.vue?vue&type=template&id=82fd8422&scoped=true"
import script from "./HoldingRow.vue?vue&type=script&lang=js"
export * from "./HoldingRow.vue?vue&type=script&lang=js"

import "./HoldingRow.vue?vue&type=style&index=0&id=82fd8422&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fd8422"]])

export default __exports__